import { AppText } from "@toothfairy/shared-ui";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppPopup from "@toothfairy/shared-ui/AppPopup";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React, { useMemo, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { routes } from "../../../Router/routes";
import { useHistory } from "../../../Router";
import AppAvatar from "@toothfairy/shared-ui/AppAvatar";
import { Platform } from "react-native";
import ImagePlaceholder from "../../../Components/ImagePlaceholder";
import useAPI from "@toothfairy/shared-api/useApi";
import Files from "../../../API/Files";
import envConfig from "../../../../envConfig";
import { TouchableWithoutFeedback } from "react-native-web";

const AppAccountAvatar = ({ handleSignOut, user, showPopup = false }) => {
  const { currentTheme } = AppTheme.useTheme();
  const history = useHistory();
  const { t } = useTranslation();
  const [profileImage, setProfileImage] = useState(null);

  const { apiRequest: S3downloadUrlRequest } = useAPI(
    Files.downloadUrlGeneration,
    envConfig
  );

  useEffect(() => {
    if (user?.image) {
      getProfileImageUrl(user.image);
    }
  }, [user?.image]);

  const getProfileImageUrl = async (imagePath) => {
    try {
      const _url = await S3downloadUrlRequest({
        filename: `imported-image/root/${imagePath}`,
        context: "pdf",
        workspaceid: "root",
      });
      if (_url?.url) {
        setProfileImage(_url.url);
      }
    } catch (error) {
      console.log("Error getting profile image URL", error);
    }
  };
  const options = useMemo(
    () => [
      {
        label: t("sidemenu.profile"),
        icon: AppAssets.icons.account,
        to: routes.profile,
      },
      {
        label: t("sidemenu.logout"),
        icon: AppAssets.icons.logout,
        to: routes.workspaces,
        onPress: handleSignOut,
        color: currentTheme?.theme?.red,
      },
    ],
    [handleSignOut, currentTheme, t]
  );

  return showPopup ? (
    <AppPopup
      style={{ alignSelf: "flex-end" }}
      isAvatar
      isTriggerIcon={false}
      isEnabled
      avatarLabel={user?.username || t("sidemenu.notApplicable")}
      avatarSize={36}
      avatarRatio={0.5}
      topOffset={-36}
      leftOffset={-36}
      isCloseButtonVisible={false}
      placement="left"
      avatarLabelColor={currentTheme?.theme?.white}
      avatarStyle={{
        backgroundColor: currentTheme?.theme?.primary,
      }}
    >
      {options.map((u) => {
        return (
          <AppText
            wrapperStyle={{
              paddingHorizontal: 8,
              paddingVertical: 10,
            }}
            iconSize={20}
            style={{
              marginLeft: 20,
            }}
            leftIcon={u.icon}
            isClickable
            isHoverable={false}
            color={u.color}
            onPress={() => {
              if (u.onPress) {
                u.onPress();
              } else if (u.to) {
                history.push(u?.to);
              }
            }}
          >
            {u?.label}
          </AppText>
        );
      })}
    </AppPopup>
  ) : user?.image && profileImage ? (
    <TouchableWithoutFeedback
      onPress={() => {
        history.push("/profile/profile_settings");
      }}
    >
      <div style={{ zIndex: 10000 }}>
        <ImagePlaceholder
          disabled
          imagePath={profileImage}
          isFileUploadInProgress={false}
          fileUploadProgress={0}
          isLargeLogo={false}
          style={{
            borderRadius: 12,
            height: 24,
            width: 24,
            cursor: Platform.OS === "web" ? "pointer" : "default",
          }}
          forcedImgHeight={24}
          forcedImgWidth={24}
          forcedImgRadius={12}
        />
      </div>
    </TouchableWithoutFeedback>
  ) : (
    <AppAvatar
      label={user?.username || t("sidemenu.notApplicable")}
      size={24}
      avatarLabelColor={currentTheme?.theme?.white}
      onPress={() => {
        history.push("/profile/profile_settings");
      }}
      style={{
        backgroundColor: currentTheme?.theme?.primary,
        cursor: Platform.OS === "web" && "pointer",
      }}
      ratio={0.5}
    />
  );
};

export default AppAccountAvatar;
